import { render, staticRenderFns } from "./DasSelect.vue?vue&type=template&id=1ab80cba&scoped=true"
import script from "./DasSelect.vue?vue&type=script&lang=js"
export * from "./DasSelect.vue?vue&type=script&lang=js"
import style0 from "./DasSelect.vue?vue&type=style&index=0&id=1ab80cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab80cba",
  null
  
)

export default component.exports